<!-- <router-outlet></router-outlet> -->
<app-sidebar-filter [showSidebar]="showSidebar" [registration]="registration" *ngIf="page==='dashboard'"></app-sidebar-filter>
<app-login *ngIf="page==='login'"></app-login>
<app-home *ngIf="page === 'home'"></app-home>
<!-- <app-registration *ngIf = "page === 'registration' "></app-registration> -->